
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
import type { PricingTier } from "@/config/pricing";

interface PricingTierCardProps {
  tier: PricingTier;
  onSubscribe: (tier: PricingTier) => void;
}

export const PricingTierCard = ({ tier, onSubscribe }: PricingTierCardProps) => {
  return (
    <Card className={`relative flex flex-col ${tier.popular ? 'border-primary shadow-lg scale-105' : ''}`}>
      {tier.popular && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2">
          <span className="bg-primary text-primary-foreground px-3 py-1 rounded-full text-sm font-medium">
            Most Popular
          </span>
        </div>
      )}
      <CardHeader>
        <CardTitle className="text-2xl">{tier.name}</CardTitle>
        <CardDescription>{tier.description}</CardDescription>
      </CardHeader>
      <CardContent className="flex-grow">
        <div className="mb-6">
          <span className="text-4xl font-bold">{tier.price}</span>
          {tier.period && (
            <span className="text-muted-foreground">{tier.period}</span>
          )}
          {tier.customPricing && (
            <div className="text-sm text-muted-foreground mt-1">
              Based on team size and requirements
            </div>
          )}
        </div>
        <ul className="space-y-3">
          {tier.features.map((feature) => (
            <li key={feature} className="flex items-center gap-2">
              <Check className="h-5 w-5 text-primary" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      <CardFooter>
        <Button 
          className={`w-full ${tier.popular ? 'bg-primary hover:bg-primary/90' : ''}`}
          variant={tier.popular ? 'default' : 'outline'}
          onClick={() => onSubscribe(tier)}
        >
          {tier.buttonText}
        </Button>
      </CardFooter>
    </Card>
  );
};
